import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { INK, SUB, HAIR, PANEL } from "./erShared";

const IB = "w-[30px] h-[30px] inline-flex items-center justify-center rounded-[8px] disabled:opacity-30 disabled:cursor-not-allowed";

export function ERFooter({ page, size, total, rangeText, sourceText, waiting, loadMs, onPage, onSize }) {
  const pages = Math.max(1, Math.ceil(total / size));
  const from = total ? (page - 1) * size + 1 : 0, to = Math.min(total, page * size);
  return (
    <div className="flex items-center gap-3 flex-wrap px-4 py-3 rounded-b-[16px]" style={{ background: PANEL }} data-testid="er-footer">
      <span className="text-[12.5px] tabular-nums" style={{ color: SUB }} data-testid="er-footer-text">
        {total ? `${from}–${to} of ${total}` : "0"} encounter{total === 1 ? "" : "s"} · {rangeText} · {sourceText}{waiting ? " · page sorted by waiting longest" : ""}{loadMs != null ? ` · loaded in ${(loadMs / 1000).toFixed(2)} s` : ""}
      </span>
      <span className="flex-1" />
      <label className="inline-flex items-center gap-2 text-[12.5px]" style={{ color: SUB }}>Rows per page
        <select value={size} onChange={(e) => onSize(Number(e.target.value))} className="text-[12.5px] rounded-[8px] px-2 h-[30px] outline-none" style={{ border: `1px solid ${HAIR}`, background: "#fff", color: INK }} data-testid="er-page-size">
          <option value={50}>50</option><option value={100}>100</option>
        </select>
      </label>
      <span className="text-[12.5px] tabular-nums" style={{ color: SUB }} data-testid="er-page-of">Page {page} of {pages}</span>
      <button className={IB} style={{ border: `1px solid ${HAIR}`, background: "#fff" }} disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Previous page" data-testid="er-page-prev"><ChevronLeft size={15} /></button>
      <button className={IB} style={{ border: `1px solid ${HAIR}`, background: "#fff" }} disabled={page >= pages} onClick={() => onPage(page + 1)} aria-label="Next page" data-testid="er-page-next"><ChevronRight size={15} /></button>
    </div>
  );
}
